import {CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor} from "@progress/kendo-data-query";
import {
    Grid, GridColumn, GridColumnMenuFilter, GridColumnMenuProps,
    GridFilterChangeEvent,
    GridPageChangeEvent,
    GridRowClickEvent,
    GridSortChangeEvent
} from "@progress/kendo-react-grid";
import React, {useEffect, useState} from "react";
import {SCREEN_LG, SCREEN_MD, SCREEN_XL, useWindowSize} from "../utils/ScreenSizes";
import {GridCellProps} from "@progress/kendo-react-grid/dist/npm/interfaces/GridCellProps";


interface PageState {
    skip: number;
    take: number;
}
const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

interface DrawingPartsOFGridProps {
    maxWidth: string;
    data: any[],
}

const customBooleanCell = (props: GridCellProps) => {
    return (
        <td>
            {props.dataItem.is_kit ? "Si" : "No"}
        </td>
    );
}
const customCodeCell = (props: GridCellProps) => {
    return (
        <td dangerouslySetInnerHTML={{__html: props.dataItem.code}}>
        </td>
    );
}


const DrawingPartsOFGrid = (props: DrawingPartsOFGridProps) =>{
    const windowSize = useWindowSize();

    const initialDataState: PageState = { skip: 0, take: 20 };
    const [sort, setSort] = useState<SortDescriptor[]>([]);
    const [page, setPage] = useState<PageState>(initialDataState);
    const [filterable, setFilterable] = useState<boolean>(false);
    const [filter, setFilter] = useState(initialFilter);

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };

    const ColumnMenu = (props: GridColumnMenuProps) => {

        return (
            <div className={"filtro-menu"}>
                <GridColumnMenuFilter

                    {...props}
                    hideSecondFilter={true}
                    expanded={true}
                />
            </div>
        );
    };

    return(
        <Grid
            className={"articles-grid"}
            pageable={{
                buttonCount: 3,
                info: false,
                type: "numeric",
                pageSizes: [10, 25, 50 , 100, 200 ],
                previousNext: true,
            }}
            sortable={true}
            filterable={filterable}
            sort={sort}
            onSortChange={(e: GridSortChangeEvent) => {
                setSort(e.sort);
            }}
            filter={filter}
            skip={page.skip}
            take={page.take}
            onPageChange={pageChange}
            // filterable={true}
            style={{height: "80vh",maxWidth: props.maxWidth,}}
            total={props.data.length}
            onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
            // columnVirtualization={true}
            data={orderBy(filterBy(props.data, filter), sort).slice(page.skip, page.take + page.skip)}
        >
            <GridColumn  columnMenu={ColumnMenu} locked={true}  field="position" title="Posizione"              width={160}/>
            <GridColumn  columnMenu={ColumnMenu} cell={customCodeCell} field="code" title="Numero Parte"                              width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="name" title="Nome Parte"                                width={220}/>
            <GridColumn  columnMenu={ColumnMenu} field="substitutive_code" title="Codice Sostitutivo"           width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="quantity" title="Quantità"                              width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="available" title="Disponibili"                          width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="note" title="Note"                                      width={220}/>
            <GridColumn  columnMenu={ColumnMenu} field="alternative" title="Alternativa"                        width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="belongs_to_kit" title="Appartiene a kit"                width={160}  />
            <GridColumn  columnMenu={ColumnMenu} cell={customBooleanCell} field="is_kit" title="é un kit (da chieder ??)"                width={160}  />
            <GridColumn  columnMenu={ColumnMenu} field="minimum_order_quantity" title="Minima quantità ordine"  width={160}/>
            <GridColumn  columnMenu={ColumnMenu} field="oem" title="OEM"                                        width={440}/>
        </Grid>


    )
}

export default DrawingPartsOFGrid;